import { Loader2, X } from "lucide-react"
import { observer } from "mobx-react-lite"
import { toJS } from "mobx"
import { useContext, useEffect, useState } from "react"
import { fetchDevises } from "../../../http/deviceAPI"
import { fetchRegions } from "../../../http/locationAPI"
import { Context } from "../../../index"
import { useScreenSize } from "../../../utils/hooks/hooks"
import DeviceItem from "../DeviceItem/DeviceItem"
import FilterSortPanel from "./FilterSortPanel"
import Pagination from "./PaginationComponent"
import { resetSearchProducts } from "./SearchUtils"
import LoaderProducts from "../Loader/LoaderProducts"
import styles from './ShopDeviceList.module.scss'

const DeviceList = observer(() => {
	const { search, device, location } = useContext(Context)
	const [cityRepresentation, setCityRepresentation] = useState("")
	const [isShowArrowTop, setIsShowArrowTop] = useState(false)
	const isMobileScreen = useScreenSize(411)
	const isTabletScreen = useScreenSize(1024)
	const isLaptopScreen = useScreenSize(1280)
	const [isFilterVisible, setIsFilterVisible] = useState(false)
	const [isRefreshCatalog, setIsRefreshCatalog] = useState(false)
	const [isLoading, setIsLoading] = useState(true)

	useEffect(() => {
		const updateDevices = async () => {
			const data = await fetchDevises({ page: search.page })
			await device.setDevice(data)
			await resetSearchProducts(search, device, true)
			setIsLoading(false)
			console.log('search.page', search.page);
			console.log('page dev', data)
		}
		updateDevices()
	}, [device, search])

	useEffect(() => {
		const timeout = setTimeout(() => {
			fetchRegions({ name: cityRepresentation }).then((data) => {
				location.setLocations(data)
			})
		}, 500)
		location.setLocations([{ id: null, name: "", region: { id: null, name: "Загрузка..." } }])
		return () => clearTimeout(timeout)
	}, [cityRepresentation, location])

	return (
		<div>
			<div
				className={`${isLaptopScreen ? "gap-10" : "gap-0"
					} "mx-auto pb-12 flex flex-col lg:flex-row justify-between group relative w-full"`}
			>
				<div className="flex flex-col">
					<button
						className={`flex flex-row items-center gap-2 justify-center ${isTabletScreen
							? isFilterVisible
								? "hidden"
								: ""
							: "hidden"
							}`}
						onClick={() => {
							setIsFilterVisible(!isFilterVisible)
						}}
					>
						<span className="flex text-2xl">Фильтры</span>
						<img
							className="flex mt-1"
							src="/images/filter.svg"
							alt="filter-icon"
						/>
					</button>
					<div
						className={`
							transition-all duration-300 ease-in-out
							${isTabletScreen
								? isFilterVisible
									? 'opacity-100 max-h-[1000px] scale-100 visible'
									: 'opacity-0 max-h-0 scale-95 invisible overflow-hidden'
								: 'opacity-100 max-h-full scale-100 visible'
							}
							xl:border-r border-gray-900/10 pb-6 xl:pb-0 xl:mr-6 relative xl:pr-6
						  `}
					>
						<div className="sticky xl:w-80 top-6 xl:left-0">
							<div className={`flex justify-end mb-4 ${isTabletScreen
								? ''
								: "hidden"
								}`}>
								<div className='flex flex-row gap-9'>
									{' '}
									<button
										className={` rounded-xl flex items-center justify-center ${isTabletScreen ? '' : 'hidden'
											} ${styles.lightAccent}`}
										style={{ minWidth: '49.2px' }}
										onClick={() => {
											setIsFilterVisible(false)
										}}>
										<svg
											className={`${styles.customSvg}`}
											width='45px'
											height='45px'
											viewBox='0 -0.5 25 25'
											xmlns='http://www.w3.org/2000/svg'>
											<path d='M6.96967 16.4697C6.67678 16.7626 6.67678 17.2374 6.96967 17.5303C7.26256 17.8232 7.73744 17.8232 8.03033 17.5303L6.96967 16.4697ZM13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697L13.0303 12.5303ZM11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303L11.9697 11.4697ZM18.0303 7.53033C18.3232 7.23744 18.3232 6.76256 18.0303 6.46967C17.7374 6.17678 17.2626 6.17678 16.9697 6.46967L18.0303 7.53033ZM13.0303 11.4697C12.7374 11.1768 12.2626 11.1768 11.9697 11.4697C11.6768 11.7626 11.6768 12.2374 11.9697 12.5303L13.0303 11.4697ZM16.9697 17.5303C17.2626 17.8232 17.7374 17.8232 18.0303 17.5303C18.3232 17.2374 18.3232 16.7626 18.0303 16.4697L16.9697 17.5303ZM11.9697 12.5303C12.2626 12.8232 12.7374 12.8232 13.0303 12.5303C13.3232 12.2374 13.3232 11.7626 13.0303 11.4697L11.9697 12.5303ZM8.03033 6.46967C7.73744 6.17678 7.26256 6.17678 6.96967 6.46967C6.67678 6.76256 6.67678 7.23744 6.96967 7.53033L8.03033 6.46967ZM8.03033 17.5303L13.0303 12.5303L11.9697 11.4697L6.96967 16.4697L8.03033 17.5303ZM13.0303 12.5303L18.0303 7.53033L16.9697 6.46967L11.9697 11.4697L13.0303 12.5303ZM11.9697 12.5303L16.9697 17.5303L18.0303 16.4697L13.0303 11.4697L11.9697 12.5303ZM13.0303 11.4697L8.03033 6.46967L6.96967 7.53033L11.9697 12.5303L13.0303 11.4697Z' />
										</svg>
									</button>
								</div>
							</div>
							<FilterSortPanel
								isTabletScreen={isTabletScreen}
								isFilterVisible={isFilterVisible}
								setIsFilterVisible={setIsFilterVisible}
								cityRepresentation={cityRepresentation}
								setCityRepresentation={setCityRepresentation}
								locations={location.locations}
								setIsRefreshCatalog={setIsRefreshCatalog}
							/>
							<div
								className={`
									transition-all duration-300 ease-in-out text-center mt-4 text-accent flex gap-4 justify-center
									${isRefreshCatalog ? 'opacity-100 max-h-20 scale-100' : 'opacity-0 max-h-0 scale-95 overflow-hidden'}
								`}
							>
								<Loader2 className='animate-spin' />
								<p>Каталог обновился</p>
							</div>
						</div>
					</div>
				</div>

				<div
					className={`w-full ${isTabletScreen ? (isFilterVisible ? "hidden" : "") : ""
						}`}
				>
					<div className="flex flex-col border-gray-900\/10 pb-6 gap-3 w-full">
						{isLoading ?
							<LoaderProducts />
							: device.devices?.products?.length !== 0 ? (

								device.devices?.products?.map((device) => {
									console.log('device', toJS(device))
									return (
										<div key={device.id} className="w-full">
											<DeviceItem
												key={device.id}
												device={device}
											/>
										</div>
									)
								})
							) : (
								<div className="text-center mt-8 text-2xl text-gray-800" style={{ height: '40vh' }}>
									Детали не найдены
								</div>
							)}
					</div>
					<div className="flex flex-row align-center justify-center gap-10">
						{device.devices?.products?.length !== 0 ? (
							<>
								<Pagination
									device={device}
									search={search}
									isMobileScreen={isMobileScreen}
									setIsShowArrowTop={setIsShowArrowTop}
								/>
								<button
									onClick={() => {
										window.scrollTo({
											top: 0,
											behavior: "smooth",
										})
									}}
									className="flex items-center justify-center bg-accent w-11 h-11 rounded-full"
									style={{
										position: "fixed",
										bottom: `${isShowArrowTop ? "20px" : "-50px"
											}`,
										right: "30px",
										transition: "bottom 0.3s ease-in-out",
										opacity: "0.75",
									}}
								>
									<img
										className="pb-1"
										src="/images/direction-top.svg"
										alt="arrow"
										width="38px"
										height="38px"
									/>
								</button>
							</>
						) : (
							<></>
						)}
					</div>
				</div>
			</div>
		</div>
	)
})

export default DeviceList
